// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Combinations_container__Ci6hc {
  display: flex;
  flex-direction: row;
  padding-top: 50px;
  height: 100vh;
}
.Combinations_container__combinationWrapper__STEHz {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.Combinations_container__left__B7ydr {
  border-right: 2px solid #e9ecef;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  justify-content: space-between;
  width: 27rem;
}
.Combinations_container__left__B7ydr input[type=checkbox]:checked, .Combinations_container__left__B7ydr input[type=checkbox]:indeterminate {
  background-color: #00857c;
  border-color: #00857c;
}
.Combinations_container__left__header__49gHr {
  gap: 5rem;
  justify-content: space-between;
  display: flex;
  padding: 0.5rem 1rem;
  background-color: #e9ecef;
}
.Combinations_container__left__actions__wnIJJ {
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0 1rem;
}
.Combinations_container__left__actions__wnIJJ button {
  margin-bottom: 0;
}
.Combinations_container__left__counters__kBDxm {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  margin: 0 1rem;
}
.Combinations_container__left__counters__kBDxm > button {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.Combinations_container__left__toggleall__OjZ3E {
  font-weight: bold;
  white-space: nowrap;
}
.Combinations_container__left__toggleall__OjZ3E input {
  margin-right: 0.5rem;
}
.Combinations_container__left__combinations__XBiSC {
  overflow-y: auto;
  margin-right: 1px;
  overflow-y: auto;
}
.Combinations_container__left__combinations__XBiSC::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background-color: transparent;
}
.Combinations_container__left__combinations__XBiSC::-webkit-scrollbar-track {
  border-radius: 0;
}
.Combinations_container__left__combinations__XBiSC::-webkit-scrollbar-thumb {
  background-color: #bec2c5;
  border-radius: 0;
}
.Combinations_container__left__combinations__combination__items__aRFTZ {
  padding: 0.7rem 1rem;
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 1rem;
}
.Combinations_container__left__combinations__combination__items__aRFTZ .number {
  text-align: right;
}
.Combinations_container__left__combinations__combination__BdhZ2 {
  display: flex;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  flex-direction: column;
  margin: 0 1rem 1rem;
  cursor: pointer;
}
.Combinations_container__left__combinations__combination_active__YD2FZ {
  border: 3px solid #4da09a;
}
.Combinations_container__left__combinations__combination__name__5IQlF {
  display: flex;
  align-items: flex-start;
}
.Combinations_container__left__combinations__combination__name__5IQlF > input[type=checkbox] {
  flex: 0 0 15px;
}
.Combinations_container__left__combinations__combination__name__5IQlF > span {
  display: inline-block;
  flex: 0 1 auto;
}
.Combinations_container__left__combinations__combination__header__tymTU {
  display: flex;
  justify-content: space-between;
}
.Combinations_container__left__combinations__combination__header__inputErrorMsg__XY0Gm {
  color: red;
  margin: 0;
  font-size: 12px;
}
.Combinations_container__left__combinations__combination__header__wrapper__huQC4 {
  padding: 0.5rem;
  background-color: #e9ecef;
  border-bottom: 2px solid #e9ecef;
  border-radius: 9px 9px 0 0;
}
.Combinations_container__left__combinations__combination__header__tymTU input[type=checkbox] {
  margin-right: 0.5rem;
}
.Combinations_container__middle__bu9k9 {
  overflow-y: auto;
  margin-right: 1px;
  background-color: #f8f9fa;
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1.5rem;
  height: calc(100vh - 50px);
  overflow-y: auto;
}
.Combinations_container__middle__bu9k9::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background-color: transparent;
}
.Combinations_container__middle__bu9k9::-webkit-scrollbar-track {
  border-radius: 0;
}
.Combinations_container__middle__bu9k9::-webkit-scrollbar-thumb {
  background-color: #bec2c5;
  border-radius: 0;
}
.Combinations_container__middle__header__rdhb- {
  font-size: 1.3rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.Combinations_container__middle__header__rdhb- button {
  font-size: 1rem;
}
.Combinations_container__middle__modules__McNq8 {
  margin: 0 auto;
}
.Combinations_container__middle__modules__McNq8 img {
  width: 100%;
}

.Combinations_selectedTextCollectionClassName__6l6JL {
  font-size: 14px;
  line-height: normal;
  font-family: Helvetica Neue, Roboto, Arial, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/Combinations/Combinations.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AAFF;AAIE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAFJ;AAKE;EACE,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;AAHJ;AAOM;EAEE,yBAAA;EACA,qBAAA;AANR;AAUI;EACE,SAAA;EACA,8BAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;AARN;AAWI;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AATN;AAWM;EACE,gBAAA;AATR;AAaI;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AAXN;AAaM;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;AAXR;AAeI;EACE,iBAAA;EACA,mBAAA;AAbN;AAeM;EACE,oBAAA;AAbR;AAiBI;EC3EA,gBAAA;EACA,iBAAA;ED4EE,gBAAA;AAdN;AC5DI;EACI,aAAA;EACA,cAAA;EACA,6BAAA;AD8DR;AC3DI;EACI,gBAAA;AD6DR;AC1DI;EACI,yBAAA;EACA,gBAAA;AD4DR;AAIM;EACE,oBAAA;EACA,aAAA;EACA,gCAAA;EACA,gBAAA;AAFR;AAIQ;EACE,iBAAA;AAFV;AAMM;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAJR;AAMQ;EACE,yBAAA;AAJV;AAOQ;EACE,aAAA;EACA,uBAAA;AALV;AAOU;EACE,cAAA;AALZ;AAQU;EACE,qBAAA;EACA,cAAA;AANZ;AAUQ;EACE,aAAA;EACA,8BAAA;AARV;AAUU;EACE,UAAA;EACA,SAAA;EACA,eAAA;AARZ;AAWU;EACE,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;AATZ;AAYU;EACE,oBAAA;AAVZ;AAiBE;EC7IE,gBAAA;EACA,iBAAA;ED+IA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;AAfJ;ACrII;EACI,aAAA;EACA,cAAA;EACA,6BAAA;ADuIR;ACpII;EACI,gBAAA;ADsIR;ACnII;EACI,yBAAA;EACA,gBAAA;ADqIR;AAKI;EACE,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AAHN;AAKM;EACE,eAAA;AAHR;AAOI;EACE,cAAA;AALN;AAOM;EACE,WAAA;AALR;;AAWA;EACE,eAAA;EACA,mBAAA;EACA,sDAAA;AARF","sourcesContent":["@use \"/home/runner/_work/gmc-dc-pbui-fe/gmc-dc-pbui-fe/src/styles/global-variables.scss\" as *;\n@import '../../styles/mixins.scss';\n\n.container {\n  display: flex;\n  flex-direction: row;\n  padding-top: #{$navbarHeight};\n  height: 100vh;\n\n  &__combinationWrapper {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  &__left {\n    border-right: 2px solid #e9ecef;\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n    justify-content: space-between;\n    width: 27rem;\n\n    input[type='checkbox'] {\n\n      &:checked,\n      &:indeterminate {\n        background-color: #00857c;\n        border-color: #00857c;\n      }\n    }\n\n    &__header {\n      gap: 5rem;\n      justify-content: space-between;\n      display: flex;\n      padding: 0.5rem 1rem;\n      background-color: #e9ecef;\n    }\n\n    &__actions {\n      display: flex;\n      gap: 0.5rem;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: nowrap;\n      padding: 0 1rem;\n\n      button {\n        margin-bottom: 0;\n      }\n    }\n\n    &__counters {\n      display: flex;\n      gap: 1rem;\n      justify-content: space-between;\n      align-items: center;\n      margin: 0 1rem;\n\n      >button {\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n      }\n    }\n\n    &__toggleall {\n      font-weight: bold;\n      white-space: nowrap;\n\n      input {\n        margin-right: 0.5rem;\n      }\n    }\n\n    &__combinations {\n      @include custom-scrollbar();\n      overflow-y: auto;\n\n      &__combination__items {\n        padding: .7rem 1rem;\n        display: grid;\n        grid-template-columns: auto auto;\n        column-gap: 1rem;\n\n        :global(.number) {\n          text-align: right;\n        }\n      }\n\n      &__combination {\n        display: flex;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        flex-direction: column;\n        margin: 0 1rem 1rem;\n        cursor: pointer;\n\n        &_active {\n          border: 3px solid #4da09a;\n        }\n\n        &__name {\n          display: flex;\n          align-items: flex-start;\n\n          & > input[type=checkbox] {\n            flex: 0 0 15px;\n          }\n\n          & > span {\n            display: inline-block;\n            flex: 0 1 auto;\n          }\n        }\n\n        &__header {\n          display: flex;\n          justify-content: space-between;\n\n          &__inputErrorMsg {\n            color: red;\n            margin: 0;\n            font-size: 12px;\n          }\n\n          &__wrapper {\n            padding: 0.5rem;\n            background-color: #e9ecef;\n            border-bottom: 2px solid #e9ecef;\n            border-radius: 9px 9px 0 0;\n          }\n\n          input[type='checkbox'] {\n            margin-right: 0.5rem;\n          }\n        }\n      }\n    }\n  }\n\n  &__middle {\n    @include custom-scrollbar();\n\n    background-color: #f8f9fa;\n    flex-grow: 2;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    padding: 1.5rem;\n    height: calc(100vh - 50px);\n    overflow-y: auto;\n\n    &__header {\n      font-size: 1.3rem;\n      font-weight: bold;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      button {\n        font-size: 1rem;\n      }\n    }\n\n    &__modules {\n      margin: 0 auto;\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.selectedTextCollectionClassName {\n  font-size: 14px;\n  line-height: normal;\n  font-family: Helvetica Neue, Roboto, Arial, sans-serif;\n}","@mixin custom-scrollbar {\n    overflow-y: auto;\n    margin-right: 1px;\n\n    &::-webkit-scrollbar {\n        width: 0.5rem;\n        height: 0.5rem;\n        background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 0;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: #bec2c5;\n        border-radius: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Combinations_container__Ci6hc`,
	"container__combinationWrapper": `Combinations_container__combinationWrapper__STEHz`,
	"container__left": `Combinations_container__left__B7ydr`,
	"container__left__header": `Combinations_container__left__header__49gHr`,
	"container__left__actions": `Combinations_container__left__actions__wnIJJ`,
	"container__left__counters": `Combinations_container__left__counters__kBDxm`,
	"container__left__toggleall": `Combinations_container__left__toggleall__OjZ3E`,
	"container__left__combinations": `Combinations_container__left__combinations__XBiSC`,
	"container__left__combinations__combination__items": `Combinations_container__left__combinations__combination__items__aRFTZ`,
	"container__left__combinations__combination": `Combinations_container__left__combinations__combination__BdhZ2`,
	"container__left__combinations__combination_active": `Combinations_container__left__combinations__combination_active__YD2FZ`,
	"container__left__combinations__combination__name": `Combinations_container__left__combinations__combination__name__5IQlF`,
	"container__left__combinations__combination__header": `Combinations_container__left__combinations__combination__header__tymTU`,
	"container__left__combinations__combination__header__inputErrorMsg": `Combinations_container__left__combinations__combination__header__inputErrorMsg__XY0Gm`,
	"container__left__combinations__combination__header__wrapper": `Combinations_container__left__combinations__combination__header__wrapper__huQC4`,
	"container__middle": `Combinations_container__middle__bu9k9`,
	"container__middle__header": `Combinations_container__middle__header__rdhb-`,
	"container__middle__modules": `Combinations_container__middle__modules__McNq8`,
	"selectedTextCollectionClassName": `Combinations_selectedTextCollectionClassName__6l6JL`
};
export default ___CSS_LOADER_EXPORT___;
